import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d713c7c6")

_pushScopeId("data-v-d713c7c6")
const _hoisted_1 = {
  action: "",
  autocomplete: "off"
}
const _hoisted_2 = {
  key: 0,
  class: "data second"
}
const _hoisted_3 = { class: "input-border" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Adresa", -1)
const _hoisted_6 = { class: "group" }
const _hoisted_7 = { class: "border-gr short date" }
const _hoisted_8 = { class: "data second" }
const _hoisted_9 = { class: "input-border" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Soubor", -1)
const _hoisted_12 = { class: "group" }
const _hoisted_13 = { class: "border-gr short date" }
const _hoisted_14 = { class: "end-form" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("form", _hoisted_1, [
    (_ctx.createdFile !== '')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.createdFile), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("input", {
              id: "file",
              type: "file",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
            }, null, 32)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("button", {
        class: "convert",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
      }, "Nahrát soubor")
    ])
  ]))
})